module.exports = __webpack_public_path__ + "static/media/prod-2.8ed96cee.svg";